import styled, {css} from "styled-components";


export const RouterOutletBox = styled.div<{minHeight: string}>`
  ${props => props.minHeight 
          ? css`min-height: ${props.minHeight}`
          : ''}
`

